<ng-container *ngIf="layoutModelsLoaded">
  <app-page-header
    [componentModel]="componentModel"
    [showCancel]="true"
    [showSecondary]="false"
    [submitButtonDisabled]="submitting"
    (saveButtonClicked)="submit()"
  ></app-page-header>

  <div class="container">
    <app-brand
      #formComponent
      *ngIf="model === 'brand'"
      [formGroup]="formGroup"
      [mode]="mode"
      [componentModel]="componentModel"
      (submitChanges)="submit()"
    ></app-brand>
    <app-language
      #formComponent
      *ngIf="model === 'language'"
      [formGroup]="formGroup"
      [mode]="mode"
      (submitChanges)="submit()"
    >
    </app-language>
    <app-display-group
      #formComponent
      *ngIf="model === 'display-properties'"
      [formGroup]="formGroup"
      [mode]="mode"
      (submitChanges)="submit()"
    >
    </app-display-group>
    <app-product-status
      #formComponent
      *ngIf="model === 'product-status'"
      [formGroup]="formGroup"
      [mode]="mode"
      (submitChanges)="submit()"
    >
    </app-product-status>
    <app-manufacturer
      #formComponent
      *ngIf="model === 'manufacturer'"
      [formGroup]="formGroup"
      [mode]="mode"
      (submitChanges)="submit()"
    ></app-manufacturer>
    <app-currency
      #formComponent
      *ngIf="model === 'currency'"
      [formGroup]="formGroup"
      [mode]="mode"
      (submitChanges)="submit()"
    >
    </app-currency>
    <app-attribute-group
      #formComponent
      *ngIf="model === 'attribute-group'"
      [formGroup]="formGroup"
      [mode]="mode"
      (submitChanges)="submit()"
    >
    </app-attribute-group>
    <app-attribute-set
      #formComponent
      *ngIf="model === 'attribute-set'"
      [formGroup]="formGroup"
      [mode]="mode"
      (submitChanges)="submit()"
    >
    </app-attribute-set>
    <app-attribute
      #formComponent
      *ngIf="model === 'attribute'"
      [formGroup]="formGroup"
      [mode]="mode"
      (submitChanges)="submit()"
    >
    </app-attribute>
    <app-tag
      #formComponent
      *ngIf="model === 'tag'"
      [formGroup]="formGroup"
      [mode]="mode"
      (submitChanges)="submit()"
    >
    </app-tag>
    <app-relationship
      #formComponent
      *ngIf="model === 'relationship'"
      [formGroup]="formGroup"
      [mode]="mode"
      (submitChanges)="submit()"
    >
    </app-relationship>
    <!-- <app-export-profile
      #formComponent
      *ngIf="model === 'export-profile'"
      [formGroup]="formGroup"
      [mode]="mode"
      (submitChanges)="submit()"
    >
    </app-export-profile>
    <app-scheduler
      #formComponent
      *ngIf="model === 'scheduler'"
      [formGroup]="formGroup"
      [mode]="mode"
      (submitChanges)="submit()"
    >
    </app-scheduler> -->
    <app-form-category
      #formComponent
      *ngIf="model === 'category'"
      [formGroup]="formGroup"
      [mode]="mode"
      (submitChanges)="submit()"
    >
    </app-form-category>
    <!-- <app-product
      #formComponent
      *ngIf="model === 'product'"
      [formGroup]="formGroup"
      [mode]="mode"
      [componentModel]="componentModel"
      (submitChanges)="submit($event)"
    ></app-product> -->
  </div>
</ng-container>
